import { getDateWithSpecificFormat } from '../../../../data-transform';
import { getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';

const positiveAmountPaymentStatusOptions = [
    { id: "PAYMENT_TO_CUSTOMER_ARRANGED", label: getStatusDescriptionFromStatusValue('PAYMENT_TO_CUSTOMER_ARRANGED') },
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];
const negativeAmountPaymentStatusOptions = [
    { id: "PAYMENT_TO_HP_ARRANGED", label: getStatusDescriptionFromStatusValue('PAYMENT_TO_HP_ARRANGED') },
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];

const serviceLinePendingPaymentStatusOptions = [
    { id: "SERVICE_PAYMENT_TO_HP_ARRANGED", label: getStatusDescriptionFromStatusValue('SERVICE_PAYMENT_TO_HP_ARRANGED') },
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];

const hardwareLinePendingPaymentStatusOptions = [
    { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
];

export default function directFinancialsColumnsSpecification(config) {
    if (!config.data) return null;
    const { userType } = config;

    let result = {};
    let tableData = [];

    config.data.forEach((order, index) => {
        let row = [];
        const rowId = order.orderId + "|" + order.paymentStatus + "|" + index;

        config.columns.forEach(column => {
            const columnId = column.id;
            const displayAsIs = column.data.displayInBodyAsIs;
            let columnDataType = column.data.displayInBodyAs;
            let columnValue = null;
            let clickHandler = null;
            let columnValueData = null;
            let importantData = null;
            let isDisabled = false;

            if (columnDataType === "string") {
                if (columnId === "orderId") {
                    columnValue = order.orderId || "";
                }
                else if (columnId === "orderType") {
                    columnValue = getOrderTypeText(order.orderType) || "";
                }
                else if (columnId === "company") {
                    columnValue = order.company || "";
                }
                else if (columnId === "legalEntity") {
                    columnValue = order.legalEntity || "";
                }
                else if (columnId === "collectionDate") {
                    columnValue = getDateWithSpecificFormat(order.collectionDate) || "";
                }
                else if (columnId === "paymentType") {
                    columnValue = order.paymentType || "";
                }
                else if (columnId === "customerAmount") {
                    columnValue = order.customerAmount == null || order.customerAmount == undefined ? 0 : order.customerAmount;
                    importantData = order.customerAmount < 0 ? "NegativeAmount" : "";
                }
                else if (columnId === "currencyCode") {
                    columnValue = order.currencyCode || "";
                }
            }
            else if (columnDataType === "input") {
                columnValueData = { ...column.data };
                clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                if (columnId === "customerInvoiceDate") {
                    columnValue = order.paymentDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate, order.collectionDate, new Date()];
                }
                if (columnId === "s4OrderNumber") {
                    columnValue = order.s4OrderNumber || "";
                    columnValueData.defaultValue = columnValue;
                }
                else if (columnId === "hpInvoiceNo") {
                    columnValue = order.hpInvoiceNo;
                    columnValueData.defaultValue = columnValue;
                    // isDisabled = ['DRV Net Payment', 'HP Payment + HP2B', 'HP Net payment', 'No Customer Payment'].includes(order.paymentType) ? true : false;
                    // if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + HP2B') {
                    //     isDisabled = false;
                    // }
                    // else if(order.lineType === 'service' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = true;
                    // }
                    // else if(order.lineType === 'hardware' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentType === 'HP Credit Value') {
                    //     isDisabled = false;
                    // }
                    // else if (order.paymentType === 'HP Net payment' && order.customerAmount < 0) {
                    //     isDisabled = false;
                    // }
                    // else if (order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = false;
                    // }
                    // // Fix for SUPP2-5999
                    // else if ((order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_ARRANGED' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = false;
                    // }
                    // // Fix for SUPP2-6046
                    // else if (order.paymentStatus === 'COMPLETED' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                }
                if (columnId === "hpInvoiceDate") {
                    columnValue = order.hpInvoiceDate || "";
                    columnValueData.defaultValue = columnValue;
                    columnValueData.disableBeforeDates = [order.createdDate, new Date()];
                    // isDisabled = (order.hpInvoiceNo && userType !== "ControlTower") ? false : true;
                }
                else if (columnId === "hpPONo") {
                    columnValue = order.hpPONo || "";
                    columnValueData.defaultValue = columnValue;
                    // isDisabled = ['DRV Net Payment', 'HP Payment + HP2B', 'HP Credit value', 'HP Net payment', 'No Customer Payment'].includes(order.paymentType) ? true : false;
                    // if (order.paymentType === 'HP Net payment' && order.customerAmount > 0) {
                    //     isDisabled = false;
                    // }                    
                    // else if(order.paymentStatus === 'COMPLETED' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // // Fix for SUPP2-5999
                    // else if ((order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_ARRANGED' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // // Fix for SUPP2-6046
                    // else if (order.paymentStatus === 'COMPLETED' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "customerInvoiceNo") {
                    columnValue = order.customerInvoiceNo || "";
                    columnValueData.defaultValue = columnValue;
                    // Fix for SUPP2-6044
                    // isDisabled = ['DRV Net Payment', 'HP Credit Value', 'HP Net payment', 'No Customer Payment'].includes(order.paymentType) ? true : false;
                    // if (order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && order.paymentType === 'HP Payment + HP2B') {
                    //     isDisabled = order.isCustomerInvoiceNumberDisabled;
                    // }
                    // if (order.paymentType === 'HP Net payment' && order.customerAmount > 0) {
                    //     isDisabled = false;
                    // }                    
                    // else if(order.lineType === 'service' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = false;
                    // }
                    // else if(order.lineType === 'hardware' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = false;
                    // }
                    // else if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // // Fix for SUPP2-5999
                    // else if ((order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_ARRANGED' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // // Fix for SUPP2-6046
                    // else if (order.paymentStatus === 'COMPLETED' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                }
                else if (columnId === "customerPONo") {
                    columnValue = order.customerPONo || "";
                    columnValueData.defaultValue = columnValue;
                    // isDisabled = ['DRV Net Payment', 'HP Payment + HP2B', 'HP Net payment', 'No Customer Payment'].includes(order.paymentType) ? true : false;
                    // if (order.paymentType === 'HP Credit Value') {
                    //     isDisabled = false;
                    // }                    
                    // else if(order.lineType === 'service' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = true;
                    // }
                    // else if(order.lineType === 'hardware' && order.paymentType === 'DRV Dual Payment') {
                    //     isDisabled = false;
                    // }
                    // else if (order.paymentType === 'HP Net payment' && order.customerAmount < 0) {
                    //     isDisabled = false;
                    // }
                    // else if (order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // else if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + HP2B') {
                    //     isDisabled = false;
                    // }
                    // SUPP2-5987 FIX
                    // else if (order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                    // Fix for SUPP2-5999
                    // else if ((order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_ARRANGED' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = false;
                    // }
                    // // Fix for SUPP2-6046
                    // else if (order.paymentStatus === 'COMPLETED' && order.paymentType === 'HP Payment + CMO') {
                    //     isDisabled = true;
                    // }
                }
            }
            else if (columnDataType === "select") {
                if (columnId === "paymentStatus") {
                    columnValue = order.paymentStatus || ""
                    columnValueData = { ...column.data };
                    columnValueData.defaultValue = columnValue;
                    columnValueData.options = [{ id: order.paymentStatus, label: getStatusDescriptionFromStatusValue(order.paymentStatus) }];
                    // Fix for SUPP2-6072
                    if (order.paymentType === 'HP Payment + CMO' && order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_PENDING') {
                        columnValueData.options = [...columnValueData.options, ...serviceLinePendingPaymentStatusOptions];
                    }
                    else if (order.paymentType === 'HP Payment + CMO' && order.paymentStatus === 'SERVICE_PAYMENT_TO_HP_ARRANGED') {
                        columnValueData.options = serviceLinePendingPaymentStatusOptions;
                    }
                    else if (order.paymentType === 'HP Payment + CMO' && order.paymentStatus === 'HARDWARE_PAYMENT_TO_CUSTOMER_PENDING') {
                        columnValueData.options = [...columnValueData.options, ...hardwareLinePendingPaymentStatusOptions];
                    }
                    else if (order.lineType === 'service' && order.paymentType === 'DRV Dual Payment') {
                        columnValueData.options = order.paymentStatus !== 'COMPLETED' ?
                        [...columnValueData.options, { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }] :
                        [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }];
                    }
                    else if (order.lineType === 'hardware' && order.paymentType === 'DRV Dual Payment') {
                        columnValueData.options = order.paymentStatus !== 'COMPLETED' ? [
                            { id: "HARDWARE_PAYMENT_TO_CUSTOMER_PENDING", label: getStatusDescriptionFromStatusValue('HARDWARE_PAYMENT_TO_CUSTOMER_PENDING') },
                            { id: "HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED", label: getStatusDescriptionFromStatusValue('HARDWARE_PAYMENT_TO_CUSTOMER_ARRANGED') },
                            { id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }
                        ] : [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }]
                    }
                    else if (order.paymentStatus !== 'COMPLETED') {
                        let paymentStatusDropDownOptions = [];
                        if (order.customerAmount > 0) {
                            if (order.paymentType === 'DRV Net Payment' || order.paymentType === 'HP Payment + HP2B' || order.paymentStatus === 'PAYMENT_TO_CUSTOMER_ARRANGED') {
                                paymentStatusDropDownOptions = [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }];
                            }
                            else {
                                paymentStatusDropDownOptions = positiveAmountPaymentStatusOptions;
                            }
                        }
                        else {
                            if (order.paymentType === 'DRV Net Payment' || order.paymentType === 'HP Payment + HP2B' || order.paymentStatus === 'PAYMENT_TO_HP_ARRANGED') {
                                paymentStatusDropDownOptions = [{ id: "COMPLETED", label: getStatusDescriptionFromStatusValue('COMPLETED') }];
                            }
                            else {
                                paymentStatusDropDownOptions = negativeAmountPaymentStatusOptions;
                            }
                        }
                        columnValueData.options = [...columnValueData.options, ...paymentStatusDropDownOptions];
                    }
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                }
            }
            else if (columnDataType === "globalInvoice") {
                if (column.id === "paymentInstruction") {
                    columnValue = "download";
                    clickHandler = config.bodyButtonsHandler ? event => config.bodyButtonsHandler(event, columnId, index) : null;
                    if (order.customerAmount === 0) {
                        columnValue = "";
                        columnDataType = "string";
                    } else {
                        columnValue = "download"
                    }

                    if (order.paymentType === "HP Credit Value" && order.customerAmount > 0) {
                        isDisabled = true;
                    }
                    if (order.paymentType === 'No Customer Payment') {
                        isDisabled = true;
                    }
                }
            }

            row.push({
                [columnId]: {
                    id: columnId + "|" + rowId,
                    columnId: columnId,
                    type: columnDataType,
                    value: columnValueData || columnValue,
                    disabled: isDisabled,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    clickHandler: clickHandler,
                    importantData: importantData,
                    showInMobileViewAs: column.showInMobileViewAs,
                    isGlobal: order.paymentStatus === "SERVICE_PAYMENT_TO_HP_PENDING" && order.paymentType === "HP Payment + HP2B" ? true : false
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    })

    result['columns'] = config.columns || [];
    result['data'] = tableData || [];
    return result;
}
